module.exports = __webpack_public_path__ + "fonts/MADETommySoftBoldPERSONALUSE.1dc6e033.eot";